export interface Skills
{
  name: string;
  proficiency: number;
}

export const programmingLanguages: Skills[] = [
  {
    name: 'C#',
    proficiency: 9,
  },
  {
    name: '.Net',
    proficiency: 8,
  },
  {
    name: 'ASP.Net',
    proficiency: 6,
  },
  {
    name: 'JavaScript',
    proficiency: 6,
  },
  {
    name: 'TypeScript',
    proficiency: 7,
  },
  {
    name: 'JQuery',
    proficiency: 6,
  },
  {
    name: 'C++',
    proficiency: 3,
  },
  {
    name: 'HTML',
    proficiency: 9,
  },
  {
    name: 'CSS',
    proficiency: 9,
  },
  {
    name: 'SQL',
    proficiency: 9,
  },
];

export const javascriptFrameworks: Skills[] = [
  {
    name: 'React',
    proficiency: 6,
  },
  {
    name: 'Angular',
    proficiency: 3,
  },
  {
    name: 'Bootstrap',
    proficiency: 3,
  },
  {
    name: 'IgniteUI',
    proficiency: 3,
  },
  {
    name: 'MUI',
    proficiency: 5,
  },
  {
    name: 'Angular Material',
    proficiency: 3,
  },
  {
    name: 'Knockout.js',
    proficiency: 7,
  },
  {
    name: 'Next.js',
    proficiency: 6,
  },
  {
    name: 'TailwindCSS',
    proficiency: 6,
  },
  {
    name: 'Shadcn',
    proficiency: 6,
  },
];

export const devops: Skills[] = [
  {
    name: 'Azure DevOps',
    proficiency: 6,
  },
  {
    name: 'IIS',
    proficiency: 4,
  },
  {
    name: 'SpecFlow',
    proficiency: 6,
  },
  {
    name: 'Git',
    proficiency: 8,
  },
  {
    name: 'TurtleSVN',
    proficiency: 8,
  }
];
